export const COOKIE_JWT = "mg_at";
export const COOKIE_MAGNIT_CODE = "mg_uic";
export const COOKIE_PROFILE_INCOMPLETE = "mg_icp";
export const COOKIE_KFP_TOKEN = "mg_ksid";
export const COOKIE_MAX_AGE = 31556952;
